import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const IconCardWrapper = styled.div`
  border-radius: 4px;
  /*padding: 38px 36px 30px;*/
  padding: 19px 18px;
  background-color: ${themeGet('color.2', '#F7F7F7')};
  margin-bottom: 20px;
  text-align: ${(props) => (props.align ? props.align : 'center')};

  margin-left:10px;
  @media (max-width: 480px) {
    /*padding: 28px 20px 25px;*/
    padding: 14px 10px 12px;
  }

  .icon_card {
    display: flex; /* Utilise flexbox pour aligner les éléments en ligne */
    align-items: center; /* Centre les éléments verticalement */
  }

  .center-item {
    justify-content: center;
  }
  
  /* Le conteneur de l'icône */
  .icon-wrapper {
    flex: 0 0 auto; /* L'icône ne grandira pas et ne rétrécira pas automatiquement */
    margin-right: 10px; /* Marge entre l'icône et le titre (facultatif) */
  }
  
  /* Si vous souhaitez que l'icône soit réactive et redimensionnée selon la fenêtre, ajoutez ces styles */
  @media (max-width: 768px) {
    .icon-wrapper {
      width: 24px; /* Définissez la largeur souhaitée pour l'icône lorsqu'elle devient petite */
      height: 24px; /* Définissez la hauteur souhaitée pour l'icône lorsqu'elle devient petite */
    }
  }
 
  
  
  
  
  
  
`;

export const IconWrapper = styled.div`
  svg {
    /*width: 80px;*/
    width: 40px;
    height: auto;
    fill: ${themeGet('primary.0', '#008489')};

    @media (max-width: 767px) {
      /*width: 50px;*/
      width: 25px;
    }
  }
`;

export const TitleArea = styled.div`
  color: ${themeGet('text.0', '#2C2C2C')};
  font-size: 15px;
  font-weight: 400;
  margin-top: 10px;
`;

export default IconCardWrapper;
